import { Select } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import RatePlanInfoList from '../../components/typography/sim/RatePlanInfoList';
import { TarifService } from '../../services/simcards/Tarifs';
import { RootState } from '../../state/store';
import CurrencyFormatter from '../../utils/text/CurrencyFormatter';
import { TruncateString } from '../../utils/text/TruncateString';

const tarifService = new TarifService();

interface SelectTarif {
  onSelect: any;
  defaultValue: any;
  type: string;
}

const SelectOption: FC<SelectTarif> = ({ onSelect, defaultValue, type }) => {
  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  const [t] = useTranslation();
  const [tarifs, setTarifs] = useState(['']);

  useEffect(() => {
    (async () => {
      const { results } = await tarifService.getOptions();

      setTarifs({
        Voice: results.filter((v) => v.trf_type === 'Voice'),
        Data: results.filter((v) => v.trf_type === 'Data'),
      });
    })();
  }, []);

  if (!tarifs) {
    return <div>...loading</div>;
  }

  return (
    <Select
      showSearch
      defaultValue={defaultValue}
      style={{ width: '100%' }}
      onChange={onSelect}
      optionFilterProp="label"
      optionLabelProp="searchLabel"
      id="5"
      options={Object.keys(tarifs).map((key: string) => ({
        label: (
          <span className="underline font-bold text-slate-950 dark:text-slate-200">
            {key}
          </span>
        ),
        title: key,
        options: Object.keys(tarifs[key]).map((trf) => ({
          label: (
            <div className="flex justify-between items-center">
              <div className="flex flex-col">
                <p className="align-top ">
                  <TruncateString text={tarifs[key][trf].trf_naam} limit={32} />
                </p>
              </div>
              {tarifs[key][trf].price ? (
                <div className="flex flex-col justify-end text-right">
                  <p>
                    <CurrencyFormatter price={tarifs[key][trf].price} />/
                    {t(tarifs[key][trf].trf_roaming_price)}
                  </p>
                  <RatePlanInfoList ratePlan={tarifs[key][trf]} />
                </div>
              ) : (
                ''
              )}
            </div>
          ),
          searchLabel: tarifs[key][trf].trf_naam,
          value: tarifs[key][trf].trf_id,
        })),
      }))}
    />
  );
};

export default SelectOption;
